module.exports = __webpack_public_path__ + "img/logo.f6bed4e1.png";